// extracted by mini-css-extract-plugin
export var component = "CtaButtons-module--component--IrO5J";
export var layout = "CtaButtons-module--layout---8yQL";
export var heading = "CtaButtons-module--heading--51BMP";
export var buttons = "CtaButtons-module--buttons--Kxa26";